import type { Scope } from "@/api/types";
import { SCOPE_LABELS } from "@/lib/labels";
import { cn } from "@/lib/utils";
import { useScope } from "@/state/scope";

const SCOPES: Scope[] = ["all", "personal", "business"];

export function ScopeSelector({ className }: { className?: string }) {
  const { scope, setScope } = useScope();
  return (
    <div
      aria-label="Ámbito"
      className={cn(
        "inline-flex h-12 items-center rounded-full border border-[#dfe3eb] bg-[#f5f6fa] p-1 dark:border-[#3f4548] dark:bg-[#202629]",
        className,
      )}
      role="radiogroup"
    >
      {SCOPES.map((value) => {
        const active = value === scope;
        return (
          <button
            aria-checked={active}
            className={cn(
              "h-10 rounded-full px-4 text-sm font-semibold transition-colors",
              active
                ? "bg-white text-[#1f2433] shadow-sm dark:bg-[#101315] dark:text-white"
                : "text-[#8190b0] hover:text-[#1f2433] dark:hover:text-white",
            )}
            key={value}
            onClick={() => setScope(value)}
            role="radio"
            type="button"
          >
            {SCOPE_LABELS[value]}
          </button>
        );
      })}
    </div>
  );
}
